<template lang="html">
  <div class="chat-message">

    <div class="chat-message-content container">
      <div class="columns">
        <div class="column col-3">
          <div>{{ userName }}</div>
          <div class="chat-time">{{ dateTimeValue }}</div>
        </div>
        <div class="column col-9">
          <div class="chat-content">{{ message }}</div>
        </div>
      </div>
    </div>
  </div> <!-- end chat-message-content -->
</template>

<script>
import { formatTimeStamp } from '../helper/helper'
export default {
  name: 'ChatMessage',
  props: ['userName', 'datum', 'message'],
  computed: {
    dateTimeValue: function() {
      return formatTimeStamp(this.datum)
    }
  }
}
</script>

<style lang="css" scoped>

.chat-content {
  text-align: left;
}

.chat-time{
  font-size: 0.7em;
}
.columns {
  margin: 3px;
}
.column {
  padding: 10px 0px !important
}
</style>



// WEBPACK FOOTER //
// ChatMessage.vue?2ee5374a